// Recovered compiled webpack factory 43115. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { XW: () => a, xg: () => o });
  var n = r(16649);
  function a(e) {
    return new i((t) => {
      t(e);
    });
  }
  function o(e) {
    return new i((t, r) => {
      r(e);
    });
  }
  class i {
    constructor(e) {
      ((this._state = 0), (this._handlers = []), this._runExecutor(e));
    }
    then(e, t) {
      return new i((r, n) => {
        (this._handlers.push([
          !1,
          (t) => {
            if (e)
              try {
                r(e(t));
              } catch (e) {
                n(e);
              }
            else r(t);
          },
          (e) => {
            if (t)
              try {
                r(t(e));
              } catch (e) {
                n(e);
              }
            else n(e);
          },
        ]),
          this._executeHandlers());
      });
    }
    catch(e) {
      return this.then((e) => e, e);
    }
    finally(e) {
      return new i((t, r) => {
        let n, a;
        return this.then(
          (t) => {
            ((a = !1), (n = t), e && e());
          },
          (t) => {
            ((a = !0), (n = t), e && e());
          },
        ).then(() => {
          if (a) return void r(n);
          t(n);
        });
      });
    }
    _executeHandlers() {
      if (0 === this._state) return;
      let e = this._handlers.slice();
      ((this._handlers = []),
        e.forEach((e) => {
          e[0] ||
            (1 === this._state && e[1](this._value),
            2 === this._state && e[2](this._value),
            (e[0] = !0));
        }));
    }
    _runExecutor(e) {
      let t = (e, t) => {
          if (0 === this._state) {
            if ((0, n.Qg)(t)) return void t.then(r, a);
            ((this._state = e), (this._value = t), this._executeHandlers());
          }
        },
        r = (e) => {
          t(1, e);
        },
        a = (e) => {
          t(2, e);
        };
      try {
        e(r, a);
      } catch (e) {
        a(e);
      }
    }
  }
}
